/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
import { RestService } from '../../RestService';

class OriginService extends RestService {
    /** @ngInject */
    constructor($q, resource, $httpParamSerializerJQLike, $log) {
        super($q, resource,  $httpParamSerializerJQLike, $log, false);
        $log.debug('Service \'OriginService\' loaded');
    }
}

export { OriginService };



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/organization/service/OriginService.js